import { ServiceResponse, CreateEnquiryDto, EnquiryDto } from "@se/platform";

const IEnquiryFormServiceId = Symbol("IEnquiryFormService");

interface IEnquiryFormService {
    SubmitEnquiryForm(dto: CreateEnquiryDto, accessToken: string): Promise<ServiceResponse<EnquiryDto>>;
};

export { IEnquiryFormServiceId, IEnquiryFormService }